import { SortFilter } from 'components/Filters/SortFilter';
import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { useUserLists } from 'lib/contexts/userListsContext';
import { userIsTeamMember, userIsAdmin } from 'lib/helpers';
import { CreatorSort } from 'lib/types/filters';
import { pickBy } from 'lodash';
import { creatorSortOptions } from 'server/api/services/creatorSearch/constants';
import { CreatorSearchCriteria } from 'server/api/services/creatorSearch/types';

interface Props {
  criteria: CreatorSearchCriteria | undefined;
}

const hasMetadataFilters = (c: CreatorSearchCriteria | undefined): boolean => !!(
  c?.brands?.length
  || c?.people?.length
  || c?.companies?.length
  || c?.industries?.length
  || c?.products?.length
);

const getDefaultSort = (c: CreatorSearchCriteria | undefined): CreatorSort => {
  if (c?.list) {
    return 'submissionDate';
  }
  if (hasMetadataFilters(c)) {
    return 'relevance';
  }
  return 'mostRecentCredit';
};

export const CreatorsSort = ({ criteria }: Props) => {
  const { lists } = useUserLists();
  const currentUser = useCurrentUser();

  const getExtraSortOptions = (): Record<string, string> | undefined => {
    if (criteria?.list && lists?.find((l) => l?.publicId === criteria?.list)?.teamId) {
      const extraOptions: Record<string, string> = {
        votes: 'Most Upvotes',
        submissionDate: 'Date Added to List',
      };
      if (userIsTeamMember(currentUser) || userIsAdmin(currentUser)) {
        extraOptions.followers = 'Most Followers';
      }
      return extraOptions;
    }

    if (criteria?.list) {
      return {
        submissionDate: 'Date Added to List',
      };
    }

    if (userIsTeamMember(currentUser) || userIsAdmin(currentUser)) {
      return {
        followers: 'Most Followers',
      };
    }

    return undefined;
  };

  const getExcludedSortOptions = (): string[] => {
    const excluded = ['votes', 'submissionDate'];
    if (!hasMetadataFilters(criteria)) {
      excluded.push('relevance');
    }
    return excluded;
  };

  return (
    <SortFilter<CreatorSort>
      sortOptions={pickBy(
        creatorSortOptions, (v, k) => !getExcludedSortOptions().includes(k),
      )}
      sort={criteria?.sort}
      defaultSort={getDefaultSort(criteria)}
      extraOptions={getExtraSortOptions()}
    />
  );
};
